import React, {Component} from 'react';
import {availableLanguages, lStrings} from "../Constants/Strings";
import {NavLink} from 'react-router-dom'
import Dropdown from 'react-dropdown'
import 'react-dropdown/style.css'

const options = [
    {value: 'ja', label: '日本語'},
    {value: 'en', label: 'English'},
    {value: 'ko', label: '한국어'}
]
const currentLang = lStrings.getLanguage();


class Footer extends Component {

    navRef;
    handleScrollChange = null;

    constructor() {
        super();
        let langNum = 0;
        for (let i = 0; i < options.length; i++) {
            if (options[i].value === currentLang) {
                langNum = i;
            }
        }

        this.state = {
            navCollapse: false,
            selected: options[langNum]
        };
        this._onSelect = this._onSelect.bind(this);

        this.navRef = React.createRef();
    }

    //
    // collapseNavbar() {
    //     if (this.navRef) {
    //         const body = document.body.getBoundingClientRect();
    //         this.setState({navCollapse: this.navRef.current.getBoundingClientRect().top - body.top > 50});
    //     }
    // }
    //

    _onSelect(option) {
        console.log('You selected ', option.label);
        this.setState({selected: option});
        let lang = option.value;
        if (lang && lang !== undefined && availableLanguages.indexOf(lang) >= 0) {

        } else {
            lang = 'ja';
        }
        if (process.env.REACT_APP_HASH === 'true') {
            let href = window.location.origin + window.location.pathname;
            let hash = window.location.hash;
            hash = hash.replace(/#\/([a-z]+)\//, '#/' + lang + '/');
            window.location.assign(href + hash);
            window.location.reload(true);
        } else {
            let href = window.location.origin;
            let hash = window.location.pathname;
            hash = hash.replace(/\/([a-z]+)\//, '/' + lang + '/');
            window.location.assign(href + hash);
        }
    }

    render() {
        const defaultOption = this.state.selected;

        return (
            <footer className="l--footer">
                <div className="container">
                    <div className="row">
                        <div className="col">
                            <nav className="navbar navbar-expand-lg navbar-light pl-3 pl-md-0 d-none d-md-block pb-4">
                                <ul className="navbar-nav mr-auto mb-5" style={{'marginLeft': '-12px'}}>
                                    <li className="nav-item">
                                        <NavLink to="./main" className="nav-link">Home</NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink to="./service" className="nav-link">Service</NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink to="./team" className="nav-link">Team</NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink to="./news" className="nav-link">News</NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink to="./contact" className="nav-link">Contact</NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink to="./jobs" className="nav-link">Job</NavLink>
                                    </li>
                                </ul>
                            </nav>
                            <span
                                className="footer-copyright pl-0">&copy; {lStrings.title_company_name_formal}</span>
                            <a href="https://liteview.jp/static/privacy_policy.html" target="_blank"
                               className="footer-copyright pl-0 pl-md-4 d-block d-md-inline"
                               rel="noopener noreferrer">Privacy Policy</a>
                            <span
                                className="footer-slogan pl-0 pl-md-4 d-block d-md-inline">{lStrings.title_company_slogan}</span>
                        </div>
                        <div className="col-4 text-right mt-3 dropdown-top-container">
                            <div className="row h-100" style={{'flexDirection': 'column'}}>
                                <div className="col">
                                    <Dropdown options={options}
                                              onChange={this._onSelect}
                                              value={defaultOption}
                                              placeholder="Select an option"/>
                                </div>
                                {/*<ul className="list-inline pr-0 mb-0 d-none d-md-block">*/}
                                {/*    <li className="list-inline-item">*/}
                                {/*        <a className="nav-link" href={lStrings.sns_tweet_url}*/}
                                {/*           target="_blank"><img src="./img/share-twitter.svg" width="20" alt="Twitter"/></a>*/}
                                {/*    </li>*/}
                                {/*    <li className="list-inline-item">*/}
                                {/*        <a className="nav-link" href={lStrings.sns_share_url}*/}
                                {/*           target="_blank"><img src="./img/share-facebook.svg" width="20"*/}
                                {/*                                alt="facebooks"/></a>*/}
                                {/*    </li>*/}
                                {/*</ul>*/}
                            </div>

                        </div>
                    </div>
                </div>
            </footer>
        );
    }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/Components/Footer.js